import { Components, inputLabelClasses, Theme } from '@mui/material';

export const MuiInputLabel: Components<Theme>['MuiInputLabel'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.input.labelColor ?? theme.palette.grey[600],
      ...(theme.featureFlags.panwRebrandStubYear && {
        [`&.${inputLabelClasses.error}`]: {
          color: theme.palette.input.errorColor,
        },
      }),
    }),
    sizeSmall: {
      top: '-3px',
    },
    shrink: {
      top: '0px',
    },
  },
};
